/** Support Request categories */
export const SUPPORT_CATEGORIES = [
    'BUG_REPORT',
    'FEATURE_REQUEST',
    'QUESTION',
    'IT_PROVISIONING',
    'DAMAGE',
    'OTHER',
];
//# sourceMappingURL=support-categories.js.map